import { Style } from "../../../models/style.model";
export const featureStyle: Style = {
  color: "#9CA3AF",
  weight: 2,
  opacity: 0.2,
  fillColor: "#6B7280",
  fillOpacity: 0.6,
};

export const ownerStyle: Style = {
  color: "#d97706",
  weight: 1,
  opacity: 0.8,
  fillColor: "#fde047",
  fillOpacity: 1,
};

export const hoverStyle: Style = {
  color: "#c2410c",
  weight: 3,
  opacity: 1,
  fillColor: "#ea580c",
  fillOpacity: 0.5,
};

export const clickStyle: Style = {
  color: "#0891b2", // Change to blue on click
  weight: 4,
  opacity: 1,
  fillColor: "#0891b2",
  fillOpacity: 0.5,
};

const etSymbology = [
  { value: 0.015, color: "#5c0003" },
  { value: 0.03, color: "#9e0142" },
  { value: 0.045, color: "#BA2049" },
  { value: 0.06, color: "#d53e4f" },
  { value: 0.075, color: "#E55649" },
  { value: 0.09, color: "#f46d43" },
  { value: 0.105, color: "#F98E52" },
  { value: 0.12, color: "#fdae61" },
  { value: 0.135, color: "#FEC776" },
  { value: 0.15, color: "#fee08b" },
  { value: 0.165, color: "#F2EB92" },
  { value: 0.18, color: "#e6f598" },
  { value: 0.195, color: "#C9E99E" },
  { value: 0.21, color: "#abdda4" },
  { value: 0.225, color: "#89D0A5" },
  { value: 0.24, color: "#66c2a5" },
  { value: 0.255, color: "#4CA5B1" },
  { value: 0.27, color: "#3288bd" },
  { value: 0.285, color: "#486CB0" },
  { value: 0.3, color: "#5e4fa2" },
];

export const getEtColor = (value: number) => {
  let color = "#5c0003";
  etSymbology.forEach((et) => {
    if (value > et["value"]) {
      color = et["color"];
    }
  });
  return color;
};

const precipSymbology = [
  { value: 0.2, color: "#d1e1eb" },
  { value: 0.4, color: "#c6d8e4" },
  { value: 0.6, color: "#bbcfdd" },
  { value: 0.8, color: "#b0c6d6" },
  { value: 1.0, color: "#a6bdcf" },
  { value: 1.2, color: "#9bb4c8" },
  { value: 1.4, color: "#91acc2" },
  { value: 1.6, color: "#87a3bb" },
  { value: 1.8, color: "#7d9ab4" },
  { value: 2.0, color: "#7392ae" },
  { value: 2.2, color: "#6a89a7" },
  { value: 2.4, color: "#6180a1" },
  { value: 2.6, color: "#57789a" },
  { value: 2.8, color: "#4e6f94" },
  { value: 3.0, color: "#45678d" },
  { value: 3.2, color: "#3d5f87" },
  { value: 3.4, color: "#345780" },
  { value: 3.6, color: "#2b4f7a" },
  { value: 3.8, color: "#214773" },
  { value: 4.0, color: "#173f6d" },
];

export const getPrecipColor = (value: number) => {
  let color = "#d1e1eb";
  precipSymbology.forEach((precip) => {
    if (value > precip["value"]) {
      color = precip["color"];
    }
  });
  return color;
};

const cropSymbology: { [key: string]: string } = {
  Alfalfa: "#c19ed6",
  "Almonds - with cover crop": "#ffecbf",
  "Almonds - without cover crop": "#ffecbf",
  "Apples - with cover crop": "#d94a45",
  "Apples - without cover crop": "#d94a45",
  "Apricots - with cover crop": "#ffa77f",
  "Apricots - without cover crop": "#ffa77f",
  "Beans (dry)": "#8ea9e3",
  "Garbanzo Beans": "#8ea9e3",
  Blueberries: "#8cb26b",
  Carrots: "#c1de99",
  "Cherries - with cover crop": "#732600",
  "Cherries - without cover crop": "#732600",
  "Grapefruit - with cover crop": "#ffaa01",
  "Grapefruit - without cover crop": "#ffaa01",
  "Lemon - with cover crop": "#ffaa01",
  "Lemon - without cover crop": "#ffaa01",
  "Mandarin - with cover crop": "#ffaa01",
  "Mandarin - without cover crop": "#ffaa01",
  "Orange (navel) - with cover crop": "#ffaa01",
  "Orange (navel) - without cover crop": "#ffaa01",
  "Orange (valencia) - with cover crop": "#ffaa01",
  "Orange (valencia) - without cover crop": "#ffaa01",
  "Other Citrus - with cover crop": "#ffaa01",
  "Other Citrus - without cover crop": "#ffaa01",
  "Tangerines - with cover crop": "#ffaa01",
  "Tangerines - without cover crop": "#ffaa01",
  "Cole Crops (Broccoli/Cauliflower)": "#dbf2b1",
  "Corn (field)": "#002573",
  "Corn (sweet)": "#002573",
  Sorghum: "#002573",
  Sudangrass: "#002573",
  Cotton: "#ff73de",
  "Grapes (raisin) - with cover crop": "#690079",
  "Grapes (raisin) - without cover crop": "#690079",
  "Grapes (table) - with cover crop": "#690079",
  "Grapes (table) - without cover crop": "#690079",
  "Grapes (wine) - with cover crop": "#690079",
  "Grapes (wine) - without cover crop": "#690079",
  "Kiwi - with cover crop": "#90E540",
  "Kiwi - without cover crop": "#90E540",
  Lettuce: "#cee8a5",
  Cantaloupe: "#a8c981",
  Cucumbers: "#a8c981",
  "Honeydew melons": "#a8c981",
  Pumpkins: "#a8c981",
  Squash: "#a8c981",
  Watermelon: "#a8c981",
  "Figs - with cover crop": "#cc1f12",
  "Figs - without cover crop": "#cc1f12",
  "Miscellaneous Deciduous - with cover crop": "#cc1f12",
  "Miscellaneous Deciduous - without cover crop": "#cc1f12",
  "Persimmons - with cover crop": "#cc1f12",
  "Persimmons - without cover crop": "#cc1f12",
  Hemp: "#4164ab",
  Barley: "#e6e600",
  "Cover Crop": "#e6e600",
  "Forage Mix": "#e6e600",
  "Other Small Grains": "#e6e600",
  Teff: "#e6e600",
  Triticale: "#e6e600",
  Ryegrass: "#9046b8",
  "Miscellaneous Subtropical - with cover crop": "#e07912",
  "Miscellaneous Subtropical - without cover crop": "#e07912",
  "Miscellaneous Truck Crops": "#5d8a45",
  Pasture: "#e9bfff",
  "Olives - with cover crop": "#beffe7",
  "Olives - without cover crop": "#beffe7",
  Garlic: "#80a860",
  Onions: "#80a860",
  "Nectarines - with cover crop": "#d95c36",
  "Nectarines - without cover crop": "#d95c36",
  "Peaches - with cover crop": "#d95c36",
  "Peaches - without cover crop": "#d95c36",
  "Pears - with cover crop": "#ff4b01",
  "Pears - without cover crop": "#ff4b01",
  "Pecans - with cover crop": "#cfd092",
  "Pecans - without cover crop": "#cfd092",
  Peppers: "#69944e",
  "Pistachios - with cover crop": "#a5f57a",
  "Pistachios - without cover crop": "#a5f57a",
  "Plums - with cover crop": "#ffa77f",
  "Plums - without cover crop": "#ffa77f",
  "Pomegranates - with cover crop": "#d13e24",
  "Pomegranates - without cover crop": "#d13e24",
  Potatoes: "#b4d48c",
  "Prunes - with cover crop": "#ffa77f",
  "Prunes - without cover crop": "#ffa77f",
  Rice: "#66cdab",
  Safflower: "#24478f",
  Strawberries: "#759e57",
  Sunflower: "#6383c7",
  "Sweet Potatoes": "#b4d48c",
  Tomatoes: "#eaffbf",
  Turf: "#5c8117",
  Fallow: "#cdaa66",
  "Walnuts - with cover crop": "#e60000",
  "Walnuts - without cover crop": "#e60000",
  Wheat: "#e7e600",
  Oats: "#3F83F8",
  "Sugar Beets": "#8E4B10",
};

const cropSymbology_legacy: { [key: string]: string } = {
  Alfalfa: "#c19ed6",
  "Alfalfa and Alfalfa Mixtures": "#c19ed6",
  Almonds: "#ffecbf",
  "Almonds - without cover crop": "#ffecbf",
  Apples: "#d94a45",
  Apricots: "#ffa77f",
  Avocados: "#119c4d",
  "Beans (Dry)": "#8ea9e3",
  "Bush Berries": "#8cb26b",
  Carrots: "#c1de99",
  Cherries: "#732600",
  Citrus: "#ffaa01",
  "Cole Crops": "#dbf2b1",
  Sorghum: "#002573",
  "Corn, Sorghum and Sudan": "#002573",
  Cotton: "#ff73de",
  Dates: "#f7b44f",
  Eucalyptus: "#5f8575",
  "Flowers, Nursery and Christmas Tree Farms": "#99bd75",
  Grapes: "#690079",
  Greenhouse: "#55ff00",
  Kiwi: "#90E540",
  Lettuce: "#cee8a5",
  "Lettuce/Leafy Greens": "#cee8a5",
  Cucumbers: "#a8c981",
  "Melons, Squash and Cucumbers": "#a8c981",
  "Miscellaneous Deciduous": "#cc1f12",
  Hemp: "#4164ab",
  "Miscellaneous Field Crops": "#4164ab",
  Teff: "#e6e600",
  "Miscellaneous Grain and Hay": "#e6e600",
  "Miscellaneous Grasses": "#9046b8",
  "Miscellaneous Subtropical Fruits": "#e07912",
  "Miscellaneous Truck Crops": "#5d8a45",
  "Mixed Pasture": "#e9bfff",
  Olives: "#beffe7",
  "Onions and Garlic": "#80a860",
  "Onions or Garlic": "#80a860",
  "Peaches/Nectarines": "#d95c36",
  Pears: "#ff4b01",
  Pecans: "#cfd092",
  Peppers: "#69944e",
  Pistachios: "#a5f57a",
  Plums: "#ffa77f",
  Pomegranates: "#d13e24",
  Potatoes: "#b4d48c",
  Prunes: "#ffa77f",
  Rice: "#66cdab",
  Safflower: "#24478f",
  Strawberries: "#759e57",
  "Sugar beets": "#f2eeb1",
  Sunflowers: "#6383c7",
  "Sweet Potatoes": "#b4d48c",
  Tomatoes: "#eaffbf",
  "Unclassified Fallow": "#cdaa66",
  Fallow: "#cdaa66",
  Urban: "#cd6666",
  Walnuts: "#e60000",
  Wheat: "#e7e600",
  "Wild Rice": "#7cc2a9",
  "Young Perennials": "#e600a9",
  Sudan: "#002573",
  Corn: "#002573",
  Turf: "#5c8117",
};

export const getCropColor = (value: string) => {
  return cropSymbology[value];
};
